var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderSnowman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "100%",
      width: "100%",
      background: "rgb(255, 255, 255)",
      shapeRendering: "auto"
    },
    width: "137px",
    height: "137px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "scale(0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -1.91212s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "#f2f2f2",
    r: 23.8,
    cy: 68.9,
    cx: 46.8,
    style: {
      fill: "rgb(242, 242, 242)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -1.93788s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "#8cc63f",
    r: 2.7,
    cy: 63.5,
    cx: 45.7,
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -1.96364s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "#8cc63f",
    r: 2.7,
    cy: 73,
    cx: 45.7,
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -1.98939s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "#8cc63f",
    r: 2.7,
    cy: 82.5,
    cx: 45.7,
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.01515s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7 53.6l-17.5-16",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "none",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.04091s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1 52l9.4-5.7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "none",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.06667s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8 56.1L84.9 39",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "none",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.09242s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9 49.5l-15.4-1.3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "none",
    style: {
      stroke: "rgb(0, 0, 0)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.11818s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 13.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#000",
    fill: "#f2f2f2",
    cy: 39,
    cx: 45.7,
    transform: "rotate(-3.642 45.717 39.027) scale(1.00002)",
    style: {
      fill: "rgb(242, 242, 242)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.14394s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    r: 1,
    cy: 37.6,
    cx: 39.9,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.1697s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    r: 1,
    cy: 39.7,
    cx: 49.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.19545s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    fill: "#ed1c24",
    d: "M35.2 50.9c1.8-2.6 3.5-5.2 5.3-7.8.5-.7 1.5-.8 2-.1 1.1 1.6 2.2 3.3 3.4 4.9.4.6.1 1.5-.7 1.8l-8.7 2.9c-1 .3-1.9-.8-1.3-1.7z",
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.22121s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    fill: "red",
    d: "M72.4 14.9c-3.8 2.9-6.2 7.3-6.6 12.1-.3 3.7-1.1 5-2 5.2-6.3 1.7-15-2.5-23.1-7.9-.6-.4-1.5-1.1-1.8-2.2-.2-.8-.1-1.6.7-3.5.4-1 1.3-3.2 2.4-4.6 2.9-3.8 9.5-5 11.6-5.3 9.7-1.5 19-.2 25.1 1.1-1.3 1.3-1.6 1.6-6.3 5.1z",
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.24697s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    fill: "#fff",
    d: "M64.1 37.2L34 27.1c-2-.7-3.1-2.9-2.5-5l.1-.3c.7-2 2.9-3.1 5-2.5l30 10.1c2 .7 3.1 2.9 2.5 5l-.1.4c-.7 2-2.9 3.1-4.9 2.4z",
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2.27273s linear -2.27273s infinite normal forwards running spin-ca89b835-da09-47ff-bc4d-99cc034383fd"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 3.2,
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "#000",
    fill: "#fff",
    cy: 10.5,
    cx: 78.3,
    transform: "rotate(-41.384 78.336 10.532)",
    style: {
      fill: "rgb(158, 228, 253)",
      stroke: "rgb(0, 0, 0)"
    }
  })))))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "spin-ca89b835-da09-47ff-bc4d-99cc034383fd",
    "data-anikit": ""
  }, "@keyframes spin-ca89b835-da09-47ff-bc4d-99cc034383fd\n    {\n    0% {\n    animation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297);\n    transform: rotate(0deg);\n    }\n    100% {\n    transform: rotate(360deg);\n    }\n    }\n  ")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSnowman);
export default __webpack_public_path__ + "static/media/loader-snowman.3b890e49cb6fdbbc31d0c9a4a14641b7.svg";
export { ForwardRef as ReactComponent };